import { render, staticRenderFns } from "./dataBoardMessage.vue?vue&type=template&id=a1b4a580&scoped=true&"
import script from "./dataBoardMessage.vue?vue&type=script&lang=js&"
export * from "./dataBoardMessage.vue?vue&type=script&lang=js&"
import style0 from "./dataBoardMessage.vue?vue&type=style&index=0&id=a1b4a580&prod&scoped=true&lang=scss&"
import style1 from "./dataBoardMessage.vue?vue&type=style&index=1&id=a1b4a580&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b4a580",
  null
  
)

export default component.exports